import { Component } from '@angular/core';

@Component({
	selector: 'notifications-error',
	templateUrl: './notifications-error.component.html',
})
export class NotificationsErrorComponent {}
